import { formatCurrency } from "./formatters";

export const chartTickFormatters = {
  currency: (value: string) => formatCurrency(Number(value)),
};
